import { Image } from 'expo-image';
import React from 'react';
import { StyleSheet } from 'react-native';

import DarkLogo from '@/assets/onboarding/dark_logo.png';

export default function OnboardingHeaderTitle() {
  return <Image source={DarkLogo} style={styles.logo} />;
}

const styles = StyleSheet.create({
  logo: {
    width: 98,
    height: 30,
    resizeMode: 'contain',
  },
});
